import { render, staticRenderFns } from "./detail_relatedCompanies.vue?vue&type=template&id=31ec132c&scoped=true&"
import script from "./detail_relatedCompanies.vue?vue&type=script&lang=js&"
export * from "./detail_relatedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./detail_relatedCompanies.vue?vue&type=style&index=0&id=31ec132c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec132c",
  null
  
)

export default component.exports